import React from 'react';
import { ListadoConDescarga } from '../../../../../shared/components/Listas/listadoConDescarga';

export const ListadoAdjuntos = (props) =>{

  return props.options ? <ListadoConDescarga {...props} name="listadoAdjuntos"/> : null
}
export default ListadoAdjuntos